export default __webpack_public_path__ + "cb449d1f5306af1dc44feb977351b66a.png";